import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { RestaurantResponse } from "../models/RestaurantResponse";
import {Constants} from "../constants/constants";
const API_BASE_URL = Constants.API_BASE_URL;

export interface CreateRestaurantRequest {
  id: string;
  name: string;
  email: string;
  phone: string;
  description?: string;
  address: string;
  city: string;
  area: string;
  cuisineType?: string;
  logoUrl?: string;
  bannerUrl?: string;
  isActive: boolean;
  averageRating?: number;
  ratingCount?: number;
}

export interface UpdateRestaurantRequest {
  name?: string;
  address?: string;
  phone?: string;
  description?: string;
  city?: string;
  area?: string;
  latitude?: number;
  longitude?: number;
  cuisineType?: string;
  logoUrl?: string;
  bannerUrl?: string;
  isActive?: boolean;
}

export async function getUserRestaurantsAsync(
  token: string,
  userId: string,
): Promise<ResponseMessage<RestaurantResponse[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/restaurants/owner/` + userId,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function createRestaurantAsync(token: string, restaurant: CreateRestaurantRequest,): Promise<ResponseMessage<RestaurantResponse>> {
  const response = await axios.post(`${API_BASE_URL}/restaurants`,restaurant, // ✅ send body here
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function updateRestaurantAsync(
  token: string,
  id: string,
  restaurant: UpdateRestaurantRequest,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.put(
    `${API_BASE_URL}/restaurants/${id}`,
    restaurant,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getRestaurantByIdAsync(
  id: string
): Promise<ResponseMessage<RestaurantResponse>> {
  const response = await axios.get(
    `${API_BASE_URL}/restaurants/${id}`,
    {
    }
  );

  return ResponseMessage.fromJson(response.data);
}
